var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dialer-settings-main"
  }, [_c('section', {
    staticClass: "dialer-settings-section dialer-ivr-setting CallQueueSettings"
  }, [_c('div', {
    staticClass: "settingsFirstSection"
  }, [_vm.$store.getters.getIsMobile ? [_c('div', {
    staticClass: "d-flex align-items-center mb-3 calc-title-width-button w-100"
  }, [_c('b-icon', {
    staticClass: "settings-back-icon cursor_pointer",
    attrs: {
      "icon": "chevron-left",
      "font-scale": "1.5"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }), _c('h2', {
    staticClass: "dialer-settings-title w-100 mb-0 text-center"
  }, [_vm._v("Call queue")])], 1), _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip"
    }],
    class: {
      'for-disable': !_vm.getUserPermissions.call_queue
    },
    attrs: {
      "title": _vm.getUserPermissions.call_queue ? '' : 'Your package does not support this feature'
    }
  }, [_c('button', {
    staticClass: "newButton",
    attrs: {
      "disabled": !_vm.getUserPermissions.call_queue
    },
    on: {
      "click": function ($event) {
        return _vm.$modal.show('AddCallQueueModal', {
          suggested_name: `call queue ${_vm.getVoipCallQueues.length + 1}`
        });
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "squared-add-icon",
      "height": "38px",
      "width": "38px"
    }
  }), _c('span', {
    staticClass: "newButton-textPart"
  }, [_vm._v("Add call queue")])], 1)])] : [_c('h2', {
    staticClass: "dialer-settings-title mb-0 settingsFirstSection-left newer"
  }, [_c('span', {
    staticClass: "md-mar-right"
  }, [_vm._v("Call queue")]), _c('b-icon', {
    staticClass: "cursor_pointer infoKbIcon md-mar-left",
    attrs: {
      "icon": "info-circle-fill"
    },
    on: {
      "click": function ($event) {
        return _vm.$modal.show('KbInfoModal', {
          kb: 'callQueue'
        });
      }
    }
  })], 1), _c('div', {
    staticClass: "settingsFirstSection-right"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-0"
  }, [_c('div', {
    staticClass: "whiteBGinputWithGreyRoundedBorder sm-mar-left sm-mar-right seachBox"
  }, [_c('b-input', {
    attrs: {
      "type": "text",
      "placeholder": "Search call queue"
    },
    model: {
      value: _vm.filter.call_queues.search,
      callback: function ($$v) {
        _vm.$set(_vm.filter.call_queues, "search", $$v);
      },
      expression: "filter.call_queues.search"
    }
  })], 1), _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip"
    }],
    class: {
      'for-disable': !_vm.getUserPermissions.call_queue
    },
    attrs: {
      "title": _vm.getUserPermissions.call_queue ? '' : 'Your package does not support this feature'
    }
  }, [_c('button', {
    staticClass: "newButton",
    attrs: {
      "disabled": !_vm.getUserPermissions.call_queue
    },
    on: {
      "click": function ($event) {
        return _vm.$modal.show('AddCallQueueModal', {
          suggested_name: `call queue ${_vm.getVoipCallQueues.length + 1}`
        });
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "squared-add-icon",
      "height": "38px",
      "width": "38px"
    }
  }), _c('span', {
    staticClass: "newButton-textPart"
  }, [_vm._v("Add call queue")])], 1)])])])]], 2), _vm._m(0), _c('vb-table', {
    staticClass: "latestTableDesign-withBlackBorders-again showGraphIconOnlyOnHover",
    attrs: {
      "isListEmpty": _vm.filterCallQueue.length == 0,
      "listLength": _vm.filterCallQueue.length,
      "loading": _vm.api.call_queues.send
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (_ref) {
        var start = _ref.start,
          end = _ref.end;
        return [!_vm.$store.getters.getIsMobile ? _vm._l(_vm.filterCallQueue, function (callQueue, index) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: index >= start && index <= end,
              expression: "index >= start && index <= end"
            }],
            key: callQueue.voipaccount || callQueue.id,
            class: `dialer-row-select ${_vm.conditions.more == callQueue.voipaccount ? 'makeTDverticalAlignTop' : ''}`,
            on: {
              "click": function ($event) {
                callQueue.queue_service ? '' : callQueue.status != '1' ? _vm.appNotify({
                  type: 'danger',
                  message: 'Unable to proceed because this call queue is suspended'
                }) : _vm.$modal.show('EditCallQueueModal', {
                  call_queue: callQueue
                });
              }
            }
          }, [_c('td', {
            staticClass: "dialer-row-title one"
          }, [_c('Info', {
            staticClass: "w-fit-content",
            attrs: {
              "is_suspended_show": !!callQueue.voipaccount,
              "id": callQueue.voipaccount || callQueue.id
            }
          })], 1), _c('td', {
            staticClass: "dialer-row-title two"
          }, [callQueue.userDid && callQueue.userDid[0] ? _c('div', {
            staticClass: "d-flex flex-column"
          }, [_c('div', {
            staticClass: "d-flex align-items-center"
          }, [_c('span', {
            staticClass: "sm-mar-left font-weight-bold min-width-160px"
          }, [_c('span', {
            staticClass: "mr-1"
          }, [_c('img', {
            staticClass: "country-img",
            attrs: {
              "width": "45px",
              "src": _vm._f("flag_icon")(_vm._f("number_formater")(_vm._f("get_property")(callQueue, 'userDid[0].did')))
            }
          })]), _vm._v(" " + _vm._s(_vm._f("number_formater")(_vm._f("get_property")(callQueue, 'userDid[0].did'))) + " ")]), callQueue.userDid.length > 1 ? _c('div', {
            staticClass: "w-auto dialer-dropdown dialer-dropDown-latest dialer-dropDown-onRight ml-3 dialer-dropDown-p-1",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                _vm.conditions.more = _vm.conditions.more == callQueue.voipaccount ? '' : callQueue.voipaccount;
              }
            }
          }, [_c('div', {
            staticClass: "px-2 rounded more-numbers-tag"
          }, [_c('small', [_vm._v("+ " + _vm._s(callQueue.userDid.length - 1) + " more")])])]) : _vm._e()]), _vm.conditions.more == callQueue.voipaccount ? [_vm._l(callQueue.userDid.filter(function (item, index) {
            return index > 0;
          }), function (userDid, index) {
            return [_c('div', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: index >= start && index <= end,
                expression: "index >= start && index <= end"
              }],
              key: userDid.did,
              staticClass: "mt-2"
            }, [_c('div', {
              staticClass: "d-flex align-items-center sm-mar-left font-weight-bold min-width-160px"
            }, [_c('span', {
              staticClass: "mr-2 d-flex align-items-center"
            }, [_c('img', {
              staticClass: "country-img",
              attrs: {
                "width": "45px",
                "src": _vm._f("flag_icon")(_vm._f("number_formater")(userDid.did))
              }
            })]), _vm._v(" " + _vm._s(_vm._f("number_formater")(userDid.did)) + " ")])])];
          })] : _vm._e()], 2) : _vm._e()]), !_vm.getIsMobile ? _c('td', {
            staticClass: "dialer-row-title dialer-col-right four"
          }, [callQueue.queue_service ? _c('b-spinner', {
            attrs: {
              "variant": "primary",
              "type": "grow",
              "small": "",
              "label": "Spinning"
            }
          }) : _c('div', {
            staticClass: "dialer-row-title three d-flex align-items-center"
          }, [_c('span', {
            staticClass: "newThisDeviceIndicaterTextBox-25-11-2023 h-fit-content ml-0 mr-16px showOnly-OnHover-insideTable"
          }, [_vm._v(" Configure ")]), _c('button', {
            staticClass: "dialer-button dialer-button-delete-alt buttonNothing",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                callQueue.status != '1' ? _vm.appNotify({
                  type: 'danger',
                  message: 'Unable to proceed because this call queue is suspended'
                }) : _vm.$modal.show('CallQueueGraphModal', {
                  accountcode: callQueue.voipaccount
                });
              }
            }
          }, [_c('vb-icon', {
            staticClass: "graphIcon",
            attrs: {
              "icon": "graph-icon",
              "height": "40.501",
              "width": "41.374"
            }
          })], 1)])], 1) : _vm._e(), _c('td', {
            staticClass: "dialer-row-title dialer-col-right three"
          }, [!callQueue.queue_service ? _c('div', {
            staticClass: "d-flex justify-content-end"
          }, [_c('a', {
            staticClass: "dialer-link-more text-decoration-underline",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.$modal.show('CallQueueMembersModal', {
                  call_queue: callQueue,
                  type: 'CallQueueMembers'
                });
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("get_property")(callQueue, 'members.length', 0)) + " users ")])]) : _vm._e()])]);
        }) : _vm._l(_vm.filterCallQueue, function (callQueue, index) {
          return _c('tr', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: index >= start && index <= end,
              expression: "index >= start && index <= end"
            }],
            key: callQueue.voipaccount || callQueue.id,
            class: `dialer-row-select ${_vm.conditions.more == callQueue.voipaccount ? 'makeTDverticalAlignTop' : ''}`,
            on: {
              "click": function ($event) {
                callQueue.queue_service ? '' : callQueue.status != '1' ? _vm.appNotify({
                  type: 'danger',
                  message: 'Unable to proceed because this call queue is suspended'
                }) : _vm.$modal.show('EditCallQueueModal', {
                  call_queue: callQueue
                });
              }
            }
          }, [_c('td', {
            staticClass: "left"
          }, [_c('div', [_c('Info', {
            staticClass: "w-fit-content",
            attrs: {
              "is_suspended_show": !!callQueue.voipaccount,
              "id": callQueue.voipaccount || callQueue.id
            }
          }), callQueue.userDid && callQueue.userDid[0] ? _c('div', [_c('div', {
            staticClass: "d-flex align-items-center mt-2px"
          }, [_c('span', {
            staticClass: "textInsideCard",
            staticStyle: {
              "min-width": "115px"
            }
          }, [_c('span', {
            staticClass: "mr-4px"
          }, [_c('img', {
            staticClass: "country-img",
            attrs: {
              "width": "25px",
              "src": _vm._f("flag_icon")(_vm._f("number_formater")(_vm._f("get_property")(callQueue, 'userDid[0].did')))
            }
          })]), _vm._v(" " + _vm._s(_vm._f("number_formater")(_vm._f("get_property")(callQueue, 'userDid[0].did'))) + " ")]), callQueue.userDid.length > 1 ? _c('div', {
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                _vm.conditions.more = _vm.conditions.more == callQueue.voipaccount ? '' : callQueue.voipaccount;
              }
            }
          }, [_c('small', [_vm._v("(+ " + _vm._s(callQueue.userDid.length - 1) + ") ")])]) : _vm._e()]), _vm.conditions.more == callQueue.voipaccount ? [_vm._l(callQueue.userDid.filter(function (item, index) {
            return index > 0;
          }), function (userDid, index) {
            return [_c('div', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: index >= start && index <= end,
                expression: "index >= start && index <= end"
              }],
              key: userDid.did,
              staticClass: "mt-2"
            }, [_c('div', {
              staticClass: "d-flex align-items-center"
            }, [_c('span', {
              staticClass: "mr-2 d-flex align-items-center"
            }, [_c('img', {
              staticClass: "country-img",
              attrs: {
                "width": "45px",
                "src": _vm._f("flag_icon")(_vm._f("number_formater")(userDid.did))
              }
            })]), _vm._v(" " + _vm._s(_vm._f("number_formater")(userDid.did)) + " ")])])];
          })] : _vm._e()], 2) : _vm._e()], 1)]), _c('td', {
            staticClass: "right dialer-col-right"
          }, [!callQueue.queue_service ? _c('div', {
            staticClass: "d-flex justify-content-end textInsideCard"
          }, [_c('a', {
            staticClass: "text-decoration-underline",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.$modal.show('CallQueueMembersModal', {
                  call_queue: callQueue,
                  type: 'CallQueueMembers'
                });
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("get_property")(callQueue, 'members.length', 0)) + " users ")])]) : _vm._e()])]);
        })];
      }
    }, {
      key: "loading",
      fn: function () {
        return _vm._l(5, function (n) {
          return _c('tr', {
            key: n
          }, [_c('td', [_c('div', {
            staticClass: "d-flex"
          }, [_c('div', {
            staticClass: "latestShimmerDesign mr-2",
            staticStyle: {
              "height": "35px",
              "width": "35px"
            }
          }), _c('div', {
            staticClass: "d-flex flex-column justify-content-between"
          }, [_c('div', {
            staticClass: "latestShimmerDesign flex-1",
            staticStyle: {
              "height": "16px",
              "width": "60px"
            }
          }), _c('div', {
            staticClass: "latestShimmerDesign mt-1",
            staticStyle: {
              "height": "16px",
              "width": "30px"
            }
          })])])]), _c('td', [_c('div', {
            staticClass: "latestShimmerDesign",
            staticStyle: {
              "height": "20px",
              "width": "-webkit-fill-available"
            }
          })]), _c('td', [_c('div', {
            staticClass: "d-flex"
          }, [_c('div', {
            staticClass: "latestShimmerDesign mt-1",
            staticStyle: {
              "height": "20px",
              "width": "70px"
            }
          })])]), _c('td', {
            staticClass: "dialer-col-right"
          }, [_c('div', {
            staticClass: "latestShimmerDesign ml-auto",
            staticStyle: {
              "height": "48px",
              "width": "48px"
            }
          })])]);
        });
      },
      proxy: true
    }])
  }, [_c('template', {
    slot: "header"
  }, [!_vm.$store.getters.getIsMobile ? _c('tr', [_c('th', {
    staticClass: "dialer-has-sort"
  }, [_c('span', {
    staticClass: "dialer-sorted-by ascending"
  }, [_vm._v("Label")])]), _c('th', {
    staticClass: "dialer-has-sort"
  }, [_c('span', [_vm._v("Number")])]), !_vm.$store.getters.getIsMobile ? _c('th', {
    staticClass: "dialer-has-sort dialer-col-right"
  }) : _vm._e(), _c('th', {
    staticClass: "dialer-has-sort dialer-col-right"
  }, [_c('span', [_vm._v("Users")])])]) : _vm._e()])], 2)], 1), _c('EditCallQueueModal', {
    on: {
      "list-update": function ($event) {
        return _vm.fetchCallQueuesDebounce();
      }
    }
  }), _c('AddCallQueueModal', {
    on: {
      "call-queue-added": function ($event) {
        return _vm.fetchCallQueuesDebounce();
      }
    }
  }), _c('GraphModal', {
    attrs: {
      "modalName": "CallQueueGraphModal"
    },
    on: {
      "interface": function ($event) {
        return _vm.fetchCallQueuesDebounce();
      }
    }
  }), _c('AddRemoveFromList', {
    attrs: {
      "modalName": 'CallQueueMembersModal'
    },
    on: {
      "update-list": function ($event) {
        return _vm.fetchCallQueues();
      }
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "settingsSecondSection"
  }, [_c('span', {
    staticClass: "dialer-settings-intro newerTextVersion mt-0 mb-0"
  }, [_vm._v("Manage calls with virtual waiting areas. Apply fair distribution, music/messages for callers.")])]);

}]

export { render, staticRenderFns }